import { UseControllerProps } from 'react-hook-form';

export const defaultRules: UseControllerProps['rules'] = {
  required: { value: true, message: 'Este campo es requerido' },
};
